// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ta_IN']  = {
  "name": "ta_IN",
  "day": {
    "abbrev": [
      "ஞா",
      "தி",
      "செ",
      "பு",
      "வி",
      "வெ",
      "ச"
    ],
    "full": [
      "ஞாயிறு",
      "திங்கள்",
      "செவ்வாய்",
      "புதன்",
      "வியாழன்",
      "வெள்ளி",
      "சனி"
    ]
  },
  "month": {
    "abbrev": [
      "ஜன",
      "பிப்",
      "மார்",
      "ஏப்",
      "மே",
      "ஜூன்",
      "ஜூலை",
      "ஆக",
      "செப்",
      "அக்",
      "நவ",
      "டிச"
    ],
    "full": [
      "ஜனவரி",
      "பிப்ரவரி",
      "மார்ச்",
      "ஏப்ரல்",
      "மே",
      "ஜூன்",
      "ஜூலை",
      "ஆகஸ்ட்",
      "செப்டம்பர்",
      "அக்டோபர்",
      "நவம்பர்",
      "டிசம்பர்"
    ]
  },
  "meridiem": [
    "காலை",
    "மாலை"
  ],
  "date": "%A %d %B %Y",
  "time24": "%I:%M:%S  %Z",
  "dateTime": "%A %d %B %Y %I:%M:%S %p %Z",
  "time12": "%I:%M:%S %p %Z"
}

